import { render, staticRenderFns } from "./apartment-price-table-row.vue?vue&type=template&id=09dbf54a&scoped=true&"
import script from "./apartment-price-table-row.ts?vue&type=script&lang=ts&"
export * from "./apartment-price-table-row.ts?vue&type=script&lang=ts&"
import style0 from "./apartment-price-table-row.scss?vue&type=style&index=0&id=09dbf54a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dbf54a",
  null
  
)

export default component.exports